<div class="add-file-dialog">
  <h2 mat-dialog-title class="add-file-dialog__title">
    {{ "addFileDialog.title" | translate }}
  </h2>

  <mat-dialog-content class="add-file-dialog__content">
    <div
      #scrollContainer
      class="add-file-dialog__scroll"
      (scroll)="onScroll()"
    >
      <div class="add-file-dialog__grid">
        <button
          type="button"
          class="add-file-dialog__tile"
          *ngFor="let item of (media$ | async) ?? []"
          (click)="selectFile(item)"
        >
          <img
            *ngIf="isImage(item) && !isPreviewError(item)"
            class="add-file-dialog__thumb"
            [src]="getMediaUrl(item)"
            (error)="setPreviewError(item)"
            alt=""
          />
          <mat-icon
            *ngIf="!isImage(item) || isPreviewError(item)"
            class="add-file-dialog__thumb-icon"
            >insert_drive_file</mat-icon
          >
        </button>
      </div>
      <div *ngIf="isLoadingMore$ | async" class="add-file-dialog__load-more">
        <mat-progress-spinner mode="indeterminate" [diameter]="32"></mat-progress-spinner>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="add-file-dialog__actions" align="end">
    <input
      #fileInput
      type="file"
      class="add-file-dialog__file-input"
      multiple
      (change)="onFileSelected($event)"
    />
    <button
      mat-flat-button
      color="primary"
      class="add-file-dialog__upload-btn"
      (click)="onUploadClick()"
    >
      {{ "addFileDialog.uploadFromDevice" | translate }}
    </button>
    <button mat-button mat-dialog-close>
      {{ "addFileDialog.cancel" | translate }}
    </button>
  </mat-dialog-actions>
</div>
